export const CONNECT_WEBSOCKETSERVER = 'CONNECT_WEBSOCKETSERVER';
export const CONNECTED_WEBSOCKETSERVER = 'CONNECTED_WEBSOCKETSERVER';
export const CLOSE_WEBSOCKETSERVER = 'CLOSE_WEBSOCKETSERVER';
export const ERROR_WEBSOCKETSERVER = 'ERROR_WEBSOCKETSERVER';
export const UPDATE_SOCIAL_INFORMATION = 'UPDATE_SOCIAL_INFORMATION';